import {createAction, createReducer} from 'redux-act';

export const initialState = {
    isCheckboxVisible: false,
    isChecked: true,
    email: '',
};

export const setCheckboxVisibility = createAction('CHECKOUT@SET_CHECKBOX_VISIBILITY');

export const setCheckboxStatus = createAction('CHECKOUT@SET_CHECKBOX_STATUS');

export const setSubscriptionEmail = createAction('CHECKOUT@SET_SUBSCRIPTION_EMAIL');

/**
 * newsletter subscription
 */
export const newsletterSubscription = createReducer(
    {
        [`${setCheckboxVisibility}`]: (state, payload) => ({
            ...state,
            isCheckboxVisible: payload,
        }),
        [`${setCheckboxStatus}`]: (state, payload) => ({...state, isChecked: payload}),
        [`${setSubscriptionEmail}`]: (state, payload) => ({...state, email: payload}),
    },
    initialState,
);
